(async() => {
while(!window.hasOwnProperty("jQuery")||!jQuery.fn.validate||!jQuery.fn.mask) {
    await new Promise(resolve => setTimeout(resolve, 100));
}

'use strict';
var $ = jQuery;

var _calc = {

  init: function () {
    _calc.setHeatCalc();
    _calc.setHeatConvCalc();
  },

  runHeatCalc: function(els){
    
    var $msg = els.form.find('.msg'),
    width = parseFloat(els.width.val())/3.281,
    len = parseFloat(els.len.val())/3.281,
    height = parseFloat(els.height.val())/3.281,
    ins = parseFloat(els.ins.val()),
    temp = parseFloat(els.temp.val())*5/9, volume;
    $msg.text('');
    if ((width > 0) && (len > 0) && (height > 0) && (temp > 0)){
      volume = width * len * height;
      var Qv = 0.33*volume*0.5;
      var Qw = (width*height*2 + length*height*2) * 0.86 * ins;
      var Qf = width*height*0.41;
      var Qwd = (width*height*2 + length*height*2)*0.14 * 2 
      var Qall = Qv + Qw + Qf + Qwd;
      

      const btu = Qall*temp*3.412;
      $msg.html('<div>BTU/h Required: <strong>' + btu.toFixed(2) + '</strong></div>');
    }
    else{
      console.log(width+'--'+len+'--'+height+'--'+ins+'--'+temp);
      $msg.html("<div>Please fill out all required fields.</div>");
    }
  },
  setHeatCalc: function(){
    var els = {
      form: $("#heatCalc"),
      len : $('#calcLength'),
      width: $('#calcWidth'),
      height: $('#calcHeight'),
      ins : $('#calcInsul'),
      temp: $('#calcTemp')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    els.len.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.width.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.height.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.temp.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.form.validate({
      rules: {
        "calcLength": {
          digitsonly: true
        },
        "calcWidth": {
          digitsonly: true
        },
        "calcHeight": {
          digitsonly: true
        },
        "calcTemp": {
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        form.preventDefault;
        _calc.runHeatCalc(els);
        return false;
      }
    });
  },
  setHeatConvCalc: function(){
    var els = {
      form: $("#heatConvCalc"),
      btu : $('#calcBTU'),
      cal: $('#calcCal'),
      joul: $('#calcJ'),
      kw : $('#calcKWh'),
      th: $('#calcTh')
    };
    $.validator.addMethod("digitsonly", function(value, element) {
      return this.optional(element) || /^[0-9.]+$/i.test(value);
    }, "Digits only");
    els.btu.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.cal.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.joul.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.kw.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.th.mask('ZZZZZZZZZZZZ',{translation: {'Z': {pattern: /[0-9.]/, optional: true}}});
    els.form.validate({
      rules: {
        "calcBTU": {
          digitsonly: true
        },
        "calcCal": {
          digitsonly: true
        },
        "calcJ": {
          digitsonly: true
        },
        "calcKWh": {
          digitsonly: true
        },
        "calcTh": {
          digitsonly: true
        }
      },
      submitHandler: function(form) {
        form.preventDefault;
        _calc.runHeatConvCalc(els);
        return false;
      }
    });
  },
  runHeatConvCalc: function(els){
    var $msg = els.form.find('.msg'), emptyFields=0,
    btu = parseFloat(els.btu.val()),
    cal = parseFloat(els.cal.val()),
    joul = parseFloat(els.joul.val()),
    kw = parseFloat(els.kw.val()),
    th = parseFloat(els.th.val());
    $msg.text('');
    if (!btu || btu == '') emptyFields++;
    if (!cal || cal == '') emptyFields++;
    if (!joul || joul == '') emptyFields++;
    if (!kw || kw == '') emptyFields++;
    if (!th || th == '') emptyFields++;
    console.log(btu+'--'+cal+'--'+joul+'--'+kw+'--'+th);
    if (emptyFields == 5){
      $msg.html("<div>Please fill out any field.</div>");
    }
    else if (emptyFields < 4){
      $msg.html("<div>Please fill out only one field.</div>");
    }
    else {
      if (btu && btu != ''){
        cal = btu * 252.16;
        joul = btu * 1055.0558526;
        kw = btu * 0.00029307106944;
        th = btu * 0.0000100;
      }
      else if (cal && cal != ''){
        btu = cal / 252.16;
        joul = cal * 4.184;
        kw = cal * 0.0000012;
        th = cal * 0.00000039652608749183;
      }
      else if (joul && joul != ''){
        btu = joul / 1055.0558526;
        cal = joul / 4.184;
        kw = joul * 0.000000277777778;
        th = joul * 0.0000000094782;
      }
      else if (kw && kw != ''){
        btu = kw / 0.00029307106944;
        cal = kw / 0.0000012;
        joul = kw / 0.000000277777778;
        th = kw * 0.034121;
      }
      else if (th && th != ''){
        btu = th / 0.0000100;
        cal = th / 0.00000039652608749183;
        joul = th / 0.0000000094782;
        kw = th / 0.034121;
      }
      els.btu.val(btu);
      els.cal.val(cal);
      els.joul.val(joul);
      els.kw.val(kw);
      els.th.val(th);
    }
  }
};

$(document).ready(_calc.init);

})();